/** @jsxImportSource react */
import { useEffect, useState } from 'react'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, ToggleButton, ToggleButtonGroup, Typography,
} from '@mui/material'
import { useEntityFields } from '../automation/useEntityFields'
import { entityLabelPlural } from '../../utils/helpers'
import { FIELD_ACCESS } from './roleModel'

/** Per-field access for one record type: Edit (default) / Read-only / Hidden. */
const FieldAccessDialog = ({ entityType, value, onSave, onClose }) => {
  const { fields } = useEntityFields(entityType)
  const [access, setAccess] = useState(value || {})
  useEffect(() => { setAccess(value || {}) }, [value, entityType])
  const set = (key, level) => setAccess((prev) => {
    const next = { ...prev }
    if (!level || level === 'EDIT') delete next[key]
    else next[key] = level
    return next
  })
  return (
    <Dialog open={!!entityType} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Fields of {entityType && entityLabelPlural(entityType)}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Read-only: members see it but can’t change it. Hidden: left out everywhere (forms, lists, filters, exports, dashboards).
        </Typography>
        <Stack spacing={1}>
          {fields.map((f) => (
            <Stack key={f.fieldKey} direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }} noWrap>{f.label}</Typography>
              <ToggleButtonGroup exclusive size="small" value={access[f.fieldKey] || 'EDIT'} onChange={(_, v) => v && set(f.fieldKey, v)}
                aria-label={`Access to ${f.label}`}>
                {FIELD_ACCESS.map((a) => <ToggleButton key={a.value} value={a.value} sx={{ px: 1.5 }}>{a.label}</ToggleButton>)}
              </ToggleButtonGroup>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onSave(access)}>Apply</Button>
      </DialogActions>
    </Dialog>
  )
}

export default FieldAccessDialog
